import { render, staticRenderFns } from "./BrandLayout.vue?vue&type=template&id=ce8786da&scoped=true"
import script from "./BrandLayout.vue?vue&type=script&lang=ts"
export * from "./BrandLayout.vue?vue&type=script&lang=ts"
import style0 from "./BrandLayout.vue?vue&type=style&index=0&id=ce8786da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8786da",
  null
  
)

export default component.exports